module.exports = __webpack_public_path__ + "static/mascot-development-b3a04b0a89b28d75a49622039034b6de.png";